// extracted by mini-css-extract-plugin
export default {"slider":"slider___DUrlb","sliderActive":"sliderActive___LR2DZ slider___DUrlb","mobileOnly":"mobileOnly___Haenf"};